var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserDeleted = function SvgUserDeleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.53 1.47a.75.75 0 0 1 0 1.06L19.56 5.5l2.97 2.97a.75.75 0 1 1-1.06 1.06L18.5 6.56l-2.97 2.97a.75.75 0 1 1-1.06-1.06l2.97-2.97-2.97-2.97a.75.75 0 0 1 1.06-1.06l2.97 2.97 2.97-2.97a.75.75 0 0 1 1.06 0ZM7.5 13.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm0 10.5c3.314 0 6-1.679 6-3.75 0-2.071-2.686-3.75-6-3.75s-6 1.679-6 3.75c0 2.071 2.686 3.75 6 3.75Zm3.448-2.37C11.78 19.609 12 19.082 12 18.75c0-.332-.22-.859-1.052-1.38-.812-.507-2.027-.87-3.448-.87-1.42 0-2.636.363-3.448.87C3.22 17.891 3 18.418 3 18.75c0 .332.22.859 1.052 1.38.812.507 2.027.87 3.448.87 1.42 0 2.636-.363 3.448-.87Z"
  })));
};

export default SvgUserDeleted;